import React, { useEffect } from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import LoginSectionSignIn1 from '../components/sign-in/LoginSectionSignIn1';

const meta = {
  title: 'Ordio — Sign In',
  meta: [
    {
      name: 'description',
      content: 'Sign in to your Ordio account to access your secure file storage and AI-powered organization tools.',
    },
    {
      name: 'viewport',
      content: 'width=device-width, initial-scale=1',
    },
  ],
  link: [
    {
      rel: 'stylesheet',
      href: 'css/tailwind/tailwind.min.css',
    },
    {
      rel: 'stylesheet',
      href: 'https://rsms.me/inter/inter.css',
    },
    {
      rel: 'stylesheet',
      href: 'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css',
    },
  ],
  style: [
    {
      cssText: `
        body {
          background-color: #ffffff;
          font-family: 'Inter', system-ui, -apple-system, sans-serif;
          margin: 0;
          padding: 0;
          min-height: 100vh;
        }
        .dark body {
          background-color: #111827;
          color: #ffffff;
        }
      `,
    },
  ],
  script: [
    {
      src: 'js/global-2274.js',
    },
    {
      src: 'js/main.js',
    },
  ],
};

export default function Login() {
  // Ensure proper body styling on component mount
  useEffect(() => {
    // Apply body classes for consistent styling
    document.body.className = 'antialiased bg-white dark:bg-gray-900 text-gray-900 dark:text-white font-body';
    
    // Ensure minimum height for full viewport
    document.body.style.minHeight = '100vh';
    document.body.style.margin = '0';
    document.body.style.padding = '0';
    
    // Set root element styling
    const rootElement = document.getElementById('root');
    if (rootElement) {
      rootElement.className = 'min-h-screen bg-white dark:bg-gray-900';
    }
    
    // Cleanup function
    return () => {
      // Reset to default if needed, but typically we want to keep the styling
    };
  }, []);

  return (
    <React.Fragment>
      <HelmetProvider>
        <Helmet {...meta}></Helmet>
      </HelmetProvider>
      <div className="min-h-screen bg-white dark:bg-gray-900">
        <LoginSectionSignIn1 />
      </div>
    </React.Fragment>
  );
}

